export const data = {
    companyPhone: "18646391165"
};
